<p-toast />
<router-outlet></router-outlet>
<!-- Loader Modal -->
<app-loader-dialog />
